import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  ViewChild,
} from '@angular/core';
import type { IHeaderAngularComp } from 'ag-grid-angular';
import type { GridApi, IHeaderParams, IRowNode } from 'ag-grid-community';
import { every, isEmpty, some } from 'lodash';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'xea-checkbox-header-cell',
  styleUrls: ['./checkbox-header-cell.component.scss'],
  template: `
    <div class="checkbox-header-label" (click)="toggleSelection()"></div>
    <input
      #headerCheckbox
      class="x_checkbox x_md"
      type="checkbox"
      [checked]="isSelectedAllRows"
    />
  `,
  standalone: false,
})
export class CheckboxHeaderCellComponent implements IHeaderAngularComp {
  @ViewChild('headerCheckbox') public checkbox: ElementRef;

  public isSelectedAllRows: boolean = false;
  public isSelectedSomeRows: boolean = false;

  private api: GridApi;

  public constructor(private changeDetector: ChangeDetectorRef) {}

  public agInit(params: IHeaderParams): void {
    this.api = params.api;

    this.checkSelectedRows();

    params.api.addEventListener('modelUpdated', () => {
      this.checkSelectedRows();
    });

    params.api.addEventListener('rowSelected', () => {
      this.checkSelectedRows();
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public refresh(params: IHeaderParams): boolean {
    return false;
  }

  public toggleSelection(): void {
    if (this.checkbox.nativeElement.checked) {
      this.api.forEachNodeAfterFilter((node) => {
        node.setSelected(false);
      });

      return;
    }

    this.api.forEachNodeAfterFilter((node) => {
      node.setSelected(
        this.isSelectedAllRows || this.isSelectedSomeRows ? false : true,
      );
    });
  }

  private checkSelectedRows(): void {
    const filteredRows = this.getDisplayedRows();
    this.isSelectedAllRows =
      !isEmpty(filteredRows) &&
      every(filteredRows, (node) => node.isSelected());
    this.isSelectedSomeRows =
      !isEmpty(filteredRows) && some(filteredRows, (node) => node.isSelected());

    this.updateCheckboxState();

    this.changeDetector.markForCheck();
  }

  private updateCheckboxState(): void {
    if (!this.checkbox) {
      return;
    }

    const controlElement = this.checkbox.nativeElement;
    const checkedNotAll: boolean =
      this.isSelectedSomeRows && !this.isSelectedAllRows;
    controlElement.indeterminate = checkedNotAll;
  }

  private getDisplayedRows(): IRowNode[] {
    const nodes: IRowNode[] = [];
    this.api.forEachNodeAfterFilter((node) => {
      if (node.displayed) {
        nodes.push(node);
      }
    });

    return nodes;
  }
}
